module.exports = __webpack_public_path__ + "templates.product_customer_review-70a1726b.html";